import { gql } from '@apollo/client';

export const GET_ACCOUNT_DELIVERY_DRIVER_OPERATION_LOGS = gql`
    query GetAccountDeliveryDriverOperationLogs($accountId: Long!, $pageRequest: PageRequestTypeInput) {
        getAccountDeliveryDriverOperationLogs(accountId: $accountId, pageRequest: $pageRequest) {
            content {
                id
                bizType
                bizTypeName
                bizId
                operationType
                operationTypeName
                operatorId
                operatorName
                operatedAt
                changesJson
                metadataJson
                isEncrypted
                description
                createdAt
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface SystemOperationLogType {
    id: number | null;
    bizType: number;
    bizTypeName: string;
    bizId: string;
    operationType: number;
    operationTypeName: string;
    operatorId: number | null;
    operatorName: string | null;
    operatedAt: number;
    changesJson: string | null;
    metadataJson: string | null;
    isEncrypted: boolean;
    description: string | null;
    createdAt: number;
    updatedAt: number;
}

export interface GetAccountDeliveryDriverOperationLogsResponse {
    getAccountDeliveryDriverOperationLogs: {
        content: SystemOperationLogType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface GetAccountDeliveryDriverOperationLogsVariables {
    accountId: number;
    pageRequest?: {
        page?: number;
        size?: number;
    };
}

